import { render, staticRenderFns } from "./fapiao_detail.vue?vue&type=template&id=7d379dcd&scoped=true"
import script from "./fapiao_detail.vue?vue&type=script&lang=js"
export * from "./fapiao_detail.vue?vue&type=script&lang=js"
import style0 from "./fapiao_detail.vue?vue&type=style&index=0&id=7d379dcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d379dcd",
  null
  
)

export default component.exports